<template>
  <div class="zmanim-footer__container">
    <zmanim-solar-path class="zmanim-footer__solar-path" />
    <div class="zmanim-footer__dark">
      <div class="zmanim-footer__header">
        <zmanim-logo
          :live="false"
          :seconds="seconds"
          class="zmanim-footer__logo"
          @click.native="seconds = !seconds"
        />
        <div class="zmanim-footer__header_slogan">
          Tomorrow's Luach, Today.
        </div>
        <div class="zmanim-footer-link__wrapper">
          <app-footer-link
            v-for="link in columns[0].links"
            :key="link.key"
            v-bind="link"
            class="zmanim-footer__link"
          />
        </div>
      </div>
      <div class="zmanim-footer__row zmanim-footer__copyright">
        &copy; Copyright 2018 Moshe Berman. All Rights Reserved.
      </div>
    </div>
  </div>
</template>

<script>
import * as styles from '@/lib/styles'
import footerLinks from '@/lib/footerLinks'
import * as callsToAction from '@/lib/callsToAction'

import ZmanimLogo from './ZmanimLogo'
import AppFooterLink from './AppFooterLink'
import ZmanimSolarPath from './ZmanimSolarPath'

export default {
  name: 'ZmanimFooter',
  components: {
    AppFooterLink,
    ZmanimLogo,
    ZmanimSolarPath
  },
  data () {
    return {
      styles,
      columns: footerLinks.columns,
      callsToAction,
      seconds: false
    }
  },
  computed: {
    button () {
      return {
        title: 'Download on the App Store',
        color: '#ffffff',
        backgroundColor: '#000000'
      }
    }
  }
}
</script>

<style scoped>
.zmanim-footer__container {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 100%;
  z-index: 3;
  overflow: hidden;
}

.zmanim-footer__dark {
  background: linear-gradient(#111, #130904);
  /* border-top: 3px solid #ff8511; */
  width: 100%;
  /* margin-top: -6rem; */
  padding-left: 10rem;
}

.zmanim-footer__row {
  width: 60rem;
  display: flex;
  flex-direction: row;
  align-self: center;
  flex-grow: 100;
  width: 100%;
  justify-content: center;
}

.zmanim-footer__header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 10;
  width: 60rem;
  margin-top: 7.2rem;
  color: #fff;
}

.zmanim-footer__header_slogan {
  color: #9b9b9b;
  font-family: "Avenir-Roman";
  font-size: 1.125rem;
  margin-top: -1rem;
  margin-left: 7rem;
}

.zmanim-footer__logo {
  flex-grow: 0;
  width: 22.3125rem;
  height: 4.4375rem;
  margin-top: -3.2rem;
  padding: 0 2rem;
  z-index: 5;
}

.zmanim-footer-link__wrapper {
  display: flex;
  width: fit-content;
  flex-direction: column;
  align-content: stretch;
  align-items: stretch;
}

.zmanim-footer__column {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  flex-grow: 10;
  max-width: 60rem;
  color: #fff;
}

.zmanim-footer__column:first-of-type {
  margin-right: 1.53rem;
}

.zmanim-footer__column:last-of-type {
  margin-left: 1.53rem;
}

.zmanim-footer__container a {
  display: flex;
  align-items: center;
  color: #fff;
  text-decoration: none;
  margin: 0 7.1rem;
  padding: 0.5rem 4rem 0.5rem 0;
  text-align: left;
  border-bottom: 1px solid #323232;
  cursor: pointer;
}

.zmanim-footer__container a:hover {
  border-bottom: 1px solid #ff8511;
}

.zmanim-footer__container a::after {
  content: "";
  color: #fff;
}

.zmanim-footer__container a:nth-of-type(1) {
  margin-top: 2rem;
}

.zmanim-footer__copyright {
  font-family: "Avenir-Roman";
  font-size: 0.75rem;
  color: #9b9b9b;
  letter-spacing: 0;
  text-align: center;
  margin-top: 4.69rem;
  margin-bottom: 1.38rem;
}

.zmanim-solar-path__container {
  width: 100%;
  margin-left: 13.31rem;
}
</style>
